module.exports = __webpack_public_path__ + "fa-solid-900.63726a69fa60cb674591.ttf";


//////////////////
// WEBPACK FOOTER
// /app/frontend/src/assets/fontawesome/webfonts/fa-solid-900.ttf
// module id = ../../../../../src/assets/fontawesome/webfonts/fa-solid-900.ttf
// module chunks = styles